import { Descriptions, Modal, Timeline, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { RiArrowDropDownFill, RiArrowDropRightFill } from 'react-icons/ri';
import SlideDown from 'react-slidedown';
import ApplicationChangeLogView from './application-changelog-view';
import { useTheme } from 'styled-components';

const StateToTextMap = {
	application_review: 'Application Review',
	interested: 'Interested',
	toInterview: 'To Interview',
	offer: 'Offer',
	hired: 'Hired',
	rejected: 'Rejected'
};

export default function CandidateApplicationHistoryViewModal({ applications, visible = false, onCancel }) {
	const [visibleAppLogs, setVisibleAppLogs] = useState({});
	const theme = useTheme();

	const toggleAppVisibleLogs = id => setVisibleAppLogs({ ...visibleAppLogs, [id]: !visibleAppLogs[id] });
	return (
		<Modal title={'Applications History'} visible={visible} footer={null} onCancel={onCancel}>
			<div>
				<Timeline mode="left">
					{applications.map(app => (
						<Timeline.Item className="mb-2" key={app.id}>
							<div className="d-flex justify-content-between">
								<Tooltip title={dayjs(app.assignedAt).fromNow()}>
									{dayjs(app.assignedAt).format('ddd, MMM D, YYYY h:mm A')}
								</Tooltip>
							</div>
							<Descriptions layout="horizontal" column={{ xs: 1, md: 2 }} className="mt-2" size="small">
								<Descriptions.Item label="Current state">{StateToTextMap[app.state]}</Descriptions.Item>
								{app.state === 'rejected' && app.rejectionReason && (
									<Descriptions.Item label="Reason">{app.rejectionReason}</Descriptions.Item>
								)}
								<br />
								<Descriptions.Item label="Job">
									<a href={`/dashboard/job/${app.job.id}`}>{app.job.title}</a>
								</Descriptions.Item>
								<Descriptions.Item label="Company">
									<a href={`/dashboard/company/${app.company.id}`}>{app.company.name}</a>
								</Descriptions.Item>
							</Descriptions>
							<p
								style={{ cursor: 'pointer', color: theme.TA_GREEN }}
								onClick={e => toggleAppVisibleLogs(app.id)}
							>
								{visibleAppLogs[app.id] ? (
									<RiArrowDropDownFill size={24} />
								) : (
									<RiArrowDropRightFill size={24} />
								)}
								view full changelog
							</p>
							<SlideDown>
								{visibleAppLogs[app.id] && <ApplicationChangeLogView application={app} />}
							</SlideDown>
						</Timeline.Item>
					))}
				</Timeline>
			</div>
		</Modal>
	);
}
